<script setup lang="ts">
import type { LucideIcon } from 'lucide-vue-next'
import { ArrowRightIcon } from 'lucide-vue-next'

interface BadgeProps {
  title: string
  type: 'warning' | 'success' | 'error' | 'info' | 'neutral'
}

interface ActionCardProps {
  icon: LucideIcon
  title: string
  subtitle?: string
  badge?: BadgeProps
  buttonAction: string
  buttonLabel: string
  isLoading?: boolean
  isVisible?: boolean
}

const props = withDefaults(defineProps<ActionCardProps>(), {
  isLoading: false,
  isVisible: true,
})

const emit = defineEmits<{
  click: [action: string]
}>()

const handleClick = () => {
  emit('click', props.buttonAction)
}
</script>

<template>
  <div v-if="isLoading">
    <div class="skeleton h-32 w-full rounded-xl" />
  </div>
  <div
    v-else-if="isVisible"
    class="bg-primary p-6 rounded-xl flex flex-col sm:flex-row sm:items-center gap-4 text-primary-content cursor-pointer hover:bg-primary/90 transition-colors"
    @click="handleClick"
  >
    <div class="flex items-center gap-3 flex-1 min-w-0">
      <component
        :is="icon"
        :size="24"
        class="flex-shrink-0"
      />

      <div class="flex flex-1 min-w-0 items-center gap-3">
        <div class="flex flex-col gap-1">
          <span class="text-lg font-bold">
            {{ title }}
          </span>
          <span v-if="subtitle" class="text-sm text-primary-content/70">
            {{ subtitle }}
          </span>
        </div>
        <Badge
          v-if="badge"
          :color="badge.type"
          class="gap-1 flex-shrink-0 sm:flex ml-auto sm:ml-0"
        >
          <ArrowRightIcon :size="12" />
          {{ badge.title }}
        </Badge>
      </div>
    </div>

    <div class="flex flex-col sm:flex-row sm:items-center gap-3 sm:ml-auto">
      <EButton
        class="btn-secondary"
        @click="handleClick"
      >
        {{ buttonLabel }}
      </EButton>
    </div>
  </div>
</template>
